export default __webpack_public_path__ + "static/media/CRO.f3a0668d.svg";